import axios from '../index';

export const requestAllPractitioners = ({ region }) =>
  axios.get(`/fhir/CareTeam?_id=${region}-careteam,super-careteam`);

export const requestOrganization = ({ id = '' }) => axios.get(`/fhir/CareTeam/${id}`);

export const requestOrganizationEdit = ({ orgId, careTeamId, data }) =>
  axios.put(`/user-management/update-site/${orgId}/${careTeamId}`, data);

export const requestSuperCareteamEdit = ({ careTeamId, data }) =>
  axios.put(`/fhir/CareTeam/${careTeamId}`, data);
